import {useMutation} from "@tanstack/react-query";
import * as vipuskApi from "../services/vipusk.api";

export const useCreateVipuskForDemand = () =>
	useMutation({
		mutationFn: (data) => vipuskApi.createVipuskForDemand(data),
	});

export const useCreateVipuskForSupermarket = () =>
	useMutation({
		mutationFn: (data) => vipuskApi.createVipuskForSupermarket(data),
	});
